import '@polymer/polymer/polymer-legacy.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import '@polymer/paper-spinner/paper-spinner-lite.js';
import '../display-clock/display-clock.js';
import '../katapult-elements/katapult-button.js';
Polymer({
  _template: html`
    <style>
      [hidden] {
        display: none !important;
      }
      .overlay {
        position: fixed;
        display: flex;
        flex-direction: column;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 100;
        padding: 16px;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      paper-spinner-lite {
        --paper-spinner-color: var(--secondary-color) !important;
      }
      #timeSyncDialog {
        background-color: #fafafa;
        color: var(--primary-text-color);
      }
      #timeSyncDialog > katapult-button {
        position: absolute;
        top: 8px;
        right: 8px;
        border-radius: 100%;
        z-index: 1;
      }
      #header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 60px;
      }
      #jobName {
        font-size: 2em;
        text-align: center;
        word-wrap: break-word;
        word-break: break-word;
        margin-top: 15px;
        line-height: 35px;
        color: var(--primary-text-color-faded);
      }
      #email {
        text-align: center;
        margin-top: 45px;
        font-size: 12pt;
      }
      #spinner {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: center;
      }
      h2 {
        font-weight: normal;
        text-transform: uppercase;
        font-size: 15pt;
        color: var(--primary-text-color-faded);
      }
      paper-spinner-lite {
        height: 48px;
        width: 48px;
        --paper-spinner-color: white;
        --paper-spinner-stroke-width: 3px;
      }
      .vertical-flex-container {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        height: calc(100% - 30px);
        position: relative;
        top: 30px;
      }
    </style>
    <template is="dom-if" if="[[opened]]">
      <div id="timeSyncDialog" class="overlay">
        <katapult-button noBorder iconOnly on-click="close" icon="clear"></katapult-button>
        <div id="header"><h2>Sync Photo</h2></div>
        <template is="dom-if" if="[[!loading]]">
          <div class="vertical-flex-container">
            <div style="display: flex; flex-direction: column;">
              <div id="jobName">[[jobName]]</div>
              <template is="dom-if" restamp if="[[showClock]]"><display-clock active="[[opened]]"></display-clock></template>
              <template is="dom-if" restamp if="[[!showClock]]"
                ><div id="spinner"><paper-spinner alt="Loading job data" active=""></paper-spinner></div
              ></template>
            </div>
            <template is="dom-if" if="[[!otherAttributes.team_members]]">
              <div id="email">[[userEmail]]</div>
            </template>
            <template is="dom-if" if="[[otherAttributes.team_members]]">
              <div style="display:flex; width:100%; justify-content:center;">
                <input-element
                  style="display:flex; flex-grow:1; width: 100%; max-width:700px;"
                  attribute_name="team_members"
                  model='{"gui_element":"team-members"}'
                  value="{{teamMembers}}"
                  user-group="[[userGroup]]"
                  other-attributes="[[otherAttributes]]"
                  no-label-float
                  hide-attribute-name
                  username-only
                ></input-element>
              </div>
            </template>
            <template is="dom-if" if="[[!gotTimeSync]]">
              <div style="display: flex; flex-direction: column;">
                <template is="dom-if" if="[[!hasSession]]">
                  <div style="color: var(--paper-red-500); margin-bottom: 24px;">
                    You have switched devices and must re-take sync shots with all cameras
                  </div>
                </template>
                <div style="display: flex; flex-direction: column">
                  <span style="padding-bottom: 16px;">I have taken a sync photo of this device with all cameras</span>
                  <katapult-button color="var(--secondary-color)" on-click="confirmSyncTaken" loading="[[dialogIsClosing]]"
                    >Yes</katapult-button
                  >
                </div>
              </div>
            </template>
          </div>
        </template>
        <template is="dom-if" if="[[loading]]">
          <div class="overlay" style="pointer-events: none;">
            <p>Loading job data...</p>
            <paper-spinner-lite active="[[loading]]"></paper-spinner-lite>
          </div>
        </template>
      </div>
    </template>
  `,

  is: 'time-sync',

  properties: {
    gotTimeSync: {
      type: Boolean,
      notify: true,
      value: null
    },
    opened: {
      type: Boolean,
      value: false,
      notify: true
    },
    jobId: {
      type: String
    },
    jobName: {
      type: String
    },
    loading: {
      type: Boolean,
      notify: true,
      value: false,
      computed: 'computeLoading(opened, jobName, userEmail, otherAttributes)'
    },
    readOnly: {
      type: Boolean
    },
    showClock: {
      type: Boolean,
      value: false
    },
    signedIn: {
      type: Boolean
    },
    dialogIsClosing: {
      type: Boolean,
      value: false
    },
    pauseAppLoading: {
      type: Boolean,
      notify: true,
      value: null
    },
    uid: {
      type: String
    },
    userGroup: {
      type: String
    },
    otherAttributes: {
      type: Object
    },
    teamMembers: {
      type: Object,
      value: null,
      notify: true
    },
    disabled: {
      type: Boolean,
      value: false
    }
  },

  observers: [
    'checkJobId(uid, jobId)',
    'updateTeamMembers(uid, otherAttributes)',
    'teamMembersChanged(teamMembers.*)',
    'updateSyncPhotoFlags(teamMembersValid, jobIdValid, hasSession, readOnly, jobId, hasBeenClosed)'
  ],

  ready: function () {
    this.hasSession = katapultAuth.hasSession;
    katapultAuth.addEventListener('has-session-changed', (e) => {
      this.hasSession = e.detail.value;
    });
  },

  open: function () {
    if (!this.disabled) {
      this.opened = true;
      this.dialogIsClosing = false;
      this.isLastUsedDevice = this.lastUsedDeviceId == FirebaseWorker.fm.get('deviceId');
    }
  },

  computeLoading: function (opened, jobName, userEmail, otherAttributes) {
    // Only set loading if it's open
    if (opened == true) {
      // Still loading if no job name
      if (!jobName) return true;
      // Still loading if no models are set
      if (!otherAttributes) return true;
      // Still loading if there's no email
      if (!userEmail) return true;
    }
    return false;
  },

  confirmSyncTaken: async function () {
    this.dialogIsClosing = true;
    await katapultAuth._claimSession();
    localStorage.setItem(`job_id_${this.uid}`, this.jobId);
    localStorage.setItem(`job_load_time_${this.uid}`, Date.now());
    localStorage.setItem(`team_members_valid_${this.uid}`, true);
    this.teamMembersValid = this.jobIdValid = true;
    this.close();
    this.dialogIsClosing = false;
  },

  close: function (e) {
    if (e?.preventDefault) e.preventDefault();
    this.opened = false;
    this.hasBeenClosed = true;
    this.closed();
  },

  closed: function () {
    this.opened = false;
    this.fire('closed');
  },

  teamMembersChanged: function () {
    // Only write team members to localstorage when uid == _prevUid.  This means we have already checked localstorage and have its version of team members for this user.
    if (this.uid != null && this._prevUid == this.uid) {
      // Clear sync validation.
      this.teamMembersValid = false;
      localStorage.setItem(`team_members_${this.uid}`, JSON.stringify(this.teamMembers));
      localStorage.setItem(`team_members_valid_${this.uid}`, false);
    }
  },

  updateTeamMembers: function () {
    if (this.otherAttributes != null) {
      if (this.otherAttributes.team_members != null) {
        // If team members is null, initialize it to its empty form.
        if (this.teamMembers == null) this.teamMembers = { team: [{ uid: '', role: '' }] };
        if (this.uid) {
          if (this.uid != this._prevUid) {
            // Restore team member valid state for this user.
            this.teamMembersValid = JSON.parse(localStorage.getItem(`team_members_valid_${this.uid}`)) === true;
            let teamMembers = JSON.parse(localStorage.getItem(`team_members_${this.uid}`));
            if (teamMembers) {
              this.teamMembers = teamMembers;
            }
          }
          // Store previous uid so we can update team members if it changes.
          this._prevUid = this.uid;
          if (this.teamMembers.team.length == 1 && this.get('teamMembers.team.0.uid') == '') {
            let role = '';
            for (let picklistId in this.otherAttributes.team_roles.picklists) {
              role = this.otherAttributes.team_roles.picklists[picklistId][0].value;
              break;
            }
            this.unshift('teamMembers.team', { uid: this.uid, role });
          } else {
            this.set('teamMembers.team.0.uid', this.uid);
          }
        }
      } else {
        // Team members is valid if it doesn't exist in otherAttributes.
        this.teamMembersValid = true;
        this.teamMembers = null;
      }
    }
  },

  updateSyncPhotoFlags: function () {
    let gotTimeSyncIsUnknown = [this.teamMembersValid && this.jobIdValid && this.hasSession].some((x) => x == null);
    if (gotTimeSyncIsUnknown) this.gotTimeSync = null;
    else this.gotTimeSync = this.teamMembersValid && this.jobIdValid && this.hasSession;

    let showInitalTimeSync = null;
    if (this.jobId) {
      // If we can't use a worker, request we pause loading until we have a time sync or the time sync has been closed once.
      let showInitalTimeSyncIsUnknown = [this.gotTimeSync, this.readOnly, this.hasBeenClosed].some((x) => x == null);
      if (!showInitalTimeSyncIsUnknown)
        showInitalTimeSync = this.gotTimeSync === false && this.readOnly === false && this.hasBeenClosed === false;
    } else {
      showInitalTimeSync = false;
    }

    // Pause loading if we are showing an initial time sync or we don't know yet if we will show an initial time sync.
    // If we can run the time sync photo in a worker, however, we don't need to worry about pausing app loading.
    this.pauseAppLoading = showInitalTimeSync !== false && window.OffscreenCanvas == null;
    // Show loading if we don't know if we are showing an intial time sync yet or not.
    // this.loading = showInitalTimeSync == null;

    if (showInitalTimeSync === true) this.open();
  },

  checkJobId: function () {
    if (this.jobId != null && this.uid != null) {
      if (this._prevJobId != this.jobId) {
        this.hasBeenClosed = false;
      }
      if (this._prevJobId != this.jobId || this._prevUid != this.uid) {
        // Try to get last jobId for this user from localstorage along with the timestamp.
        let jobId = localStorage.getItem(`job_id_${this.uid}`);
        let jobLoadTime = parseInt(localStorage.getItem(`job_load_time_${this.uid}`));
        let jobLoadDate = jobLoadTime != null ? new Date(jobLoadTime) : null;
        let date = new Date();
        if (
          this.jobId != jobId ||
          jobLoadDate == null ||
          jobLoadDate.getDate() != date.getDate() ||
          jobLoadDate.getMonth() != date.getMonth() ||
          jobLoadDate.getFullYear() != date.getFullYear()
        ) {
          this.jobIdValid = false;
        } else {
          this.jobIdValid = true;
        }
      }
      this._prevJobId = this.jobId;
    }
  },

  shouldOpen: function () {
    this.syncPhotoNeeded = this.jobId != null && this.gotTimeSync === false && this.readOnly === false;
    if (this.syncPhotoNeeded) this.open();
  }
});
